import { Component, OnChanges, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { AuthService, ProfileService } from "src/app/data/api/services";
import { ProfileViewModel } from "src/app/data/api/models";
import { StorageMap } from "@ngx-pwa/local-storage";
import { tap, finalize } from "rxjs/operators";
import { HeaderComponent } from "../header/header.component";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { RouterOutlet } from "@angular/router";
import { FooterComponent } from "../footer/footer.component";

@Component({
    selector: "szz-container",
    templateUrl: "./container.component.html",
    styleUrls: ["./container.component.scss"],
    imports: [HeaderComponent, SidebarComponent, RouterOutlet, FooterComponent]
})
export class ContainerComponent implements OnInit {
  _sidebarOpen = false;
  showBackButton = false;
  isAuthenticated = false;
  model: ProfileViewModel = { fullName: "" };
  loading = false;

  constructor(
    private readonly location: Location,
    private readonly profileService: ProfileService,
    private readonly authService: AuthService,
    private readonly storage: StorageMap
  ) {}

  get sidebarOpen() {
    return this._sidebarOpen;
  }

  set sidebarOpen(value: boolean) {
    this._sidebarOpen = value;
    if (value) {
      document.body.style.overflow = "hidden";
      document.body.classList.add("sidebar-open");
    } else {
      document.body.style.overflow = "";
      document.body.classList.remove("sidebar-open");
    }
  }

  ngOnInit(): void {
    this.loading = true;
    this.storage.clear().subscribe({
      complete: () => {
        this.authService
          .isAuthenticated({})
          .pipe(finalize(() => (this.loading = false)))
          .subscribe({
            next: (authenticated) => {
              this.isAuthenticated = !!authenticated;
              if (this.isAuthenticated) {
                this.loadProfile();
              } else {
                this.redirectToLogin();
              }
            },
            error: () => this.redirectToLogin(),
          });
      },
    });
  }

  private loadProfile(): void {
    this.profileService
      .Self({})
      .pipe(
        tap((profile) => {
          this.model = profile ?? { fullName: "Name Undefined" };
          this.model.fullName = this.model.fullName?.trim() || "Name Undefined";
        })
      )
      .subscribe();
  }

  private redirectToLogin(): void {
    globalThis.location.replace(
      `/api/auth/login?returnUrl=${encodeURIComponent(
        globalThis.location.href
      )}`
    );
  }

  goBack(): void {
    this.location.back();
  }

  logout(): void {
    globalThis.location.href = `/api/auth/logout?returnUrl=${encodeURIComponent(
      globalThis.location.href
    )}`;
  }
}
